import { createPinia } from 'pinia'
import type { App } from 'vue'

import useTeamStore from '@/store/team'
import useDictStore from '@/store/dict'
import useThemeStore from '@/store/theme'

import { localCache } from '@/utils/comm'
import { ACCESS_TOKEN } from '@/global/constants.ts'

const pinia = createPinia()

async function registerStore(app: App<Element>) {
  // 1.use的pinia
  app.use(pinia)

  // 2.加载本地的数据
  const themeStore = useThemeStore()
  themeStore.actionInitTheme()

  const teamStore = useTeamStore()
  const dictStore = useDictStore()

  if (localCache.getCache(ACCESS_TOKEN)) {
    await teamStore.actionTeamList()
    dictStore.actionInit()
  }
}

export default registerStore
